import { IUpdateCentroCustoEnderecoUseCase } from "../../../presentation/useCases/update/update_centro_custo_endereco_use_case";
import { CentroCustoEndereco } from "../../models/centro_custo_endereco";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateCentroCustoEnderecoUseCase
 */

export class UpdateCentroCustoEnderecoUseCase implements IUpdateCentroCustoEnderecoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async updateCentroCustoEndereco(form: CentroCustoEndereco): Promise<CentroCustoEndereco> {

    const result = await this.repository.updateCentroCustoEndereco(form)
    return result;

  }
}
